module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v("Change Password")]), _vm._v(" "), (_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('oldPassword')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your current password")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('newPassword')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter your new password")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('confirmPassword')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("Please repeat password")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('form', {
    attrs: {
      "name": "change"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|required'),
      expression: "'min:8|required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "name": "oldPassword",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|required|confirmed:confirmPassword'),
      expression: "'min:8|required|confirmed:confirmPassword'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "name": "newPassword",
      "maxlength": "30",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "id": "label_name",
      "name": "confirmPassword",
      "maxlength": "30",
      "data-vv-delay": "1000"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Submit",
      "name": "submitButton",
      "title": "Submit"
    }
  })])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n          Current: "), _c('br'), _vm._v("\n          New: "), _c('br'), _vm._v("\n          Confirm:\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5df3d0ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ChangePassword.vue
// module id = 287
// module chunks = 1